// extracted by mini-css-extract-plugin
export default {"class":"LoginServicerForm_class__lKafF"};